/**
 * 异常枚举
 */
enum InvoiceState {
    CANCELLED = '作废',
    ABNORMAL = '异常',
    UNCONTROLLED = '失控',
    RED = '红冲',
    NORMAL = '正常',
    PART_RED = '部分冲红',
    ALL_RED = '全额冲红',
}
/**
 * 提交枚举
 */
enum NotionalPoolingState {
    未提交 = 0,
    已提交 = 1,
}

export { InvoiceState, NotionalPoolingState };


// WEBPACK FOOTER //
// ./src/display/apps/InvoiceInput/StateEnum.ts